import { useState } from 'react';

export const useOpener = ({ open = false } = {}) => {
  const [isOpen, setOpen] = useState(open);

  const onOpen = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const onToggle = () => {
    setOpen(!isOpen);
  };

  return { isOpen, onClose, onOpen, onToggle };
};
